window.app = window.app || {};
window.app.cw = window.app.cw || {};
window.app.cw.common = window.app.cw.common || {};

app.cw.common.PopupModal = {
    show: function (title, url, data) {
        const option = {
            title: typeof title !== 'undefined' ? title : '',
            url: typeof url !== 'undefined' ? url : '',
            data: typeof data !== 'undefined' ? data : ''
        };

        const selector = '#cw_ajax_layoutbase_common_popup_modal';
        const $existingEl = $(selector);
        if ($existingEl.length) {
            $existingEl.remove();
        }

        const markup =
            '<div id="cw_ajax_layoutbase_common_popup_modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">' +
            '<div class="modal-dialog modal-lg">' +
            '<div class="modal-content cw_ajax_modal_content">' +
            '<div class="modal-header cw_ajax_modal_header">' +
            '<h5 class="modal-title"></h5>' +
            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
            '</div>' +
            '<div class="modal-body"></div>' +
            '</div>' +
            '</div>' +
            '</div>';

        if (option.url === '') {
            console.log('No url provided.');
        }
        else {
            $('body').append(markup);

            var $el = $(selector);
            if (!$el.length) {
                console.log('Element not found. Wrong selector? ' + selector);
                return false;
            }

            $el.on('show.bs.modal', function () {
                $(this).find('.modal-title').html(option.title);
                app.cw.common.LoadingSpinner.show();
                if (option.data !== '')
                    $(this).find('.modal-body').load(option.url, option.data, function () {
                        app.cw.common.LoadingSpinner.hide();
                    });
                else
                    $(this).find('.modal-body').load(option.url, function () {
                        app.cw.common.LoadingSpinner.hide();
                    });
            });

            const $modal = new bootstrap.Modal($el);
            $modal.show();
        }
    },
    hide: function () {
        const $el = document.querySelector('#cw_ajax_layoutbase_common_popup_modal');
        const $modal = bootstrap.Modal.getOrCreateInstance($el);
        $modal.hide();
    }
};